/* eslint-disable no-unused-vars */
import React, { lazy, Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
// import TrackBuilder from "../../../components/Mc12/TrackBuilder/TrackBuilder.component";
import TrackInfo from "../../../components/Mc12/TrackInfo/TrackInfo.component";
import Navigator from "../../../layouts/Navigator/Navigator";
import { selectMc12Steps, selectTrack, setMc12CurrentStep } from "../../../store/slices/mc12";
import { showSnackbar } from "../../../store/slices/retrofit";
import { updateConfiguration } from "../../../store/slices/common";
import Spinner from "../../../components/common/Icons/Spinner/Spinner";

const TrackBuilder = lazy(() => import("../../../components/Mc12/TrackBuilder/TrackBuilder.component"));

const BuildTrack = () => {
  const dispatch = useDispatch();
  const track = useSelector(selectTrack);
  const mc12Steps = useSelector(selectMc12Steps);

  function continueCondition() {
    return (
      track.shouldRecalculateGuideRails === false &&
      track.length > 0 &&
      track.calculatedCarriers.reduce((acc, carrier) => {
        if (carrier.quantityPerSet === "10_PIECES") {
          return acc + carrier.quantity * 10;
        } else {
          return acc + carrier.quantity;
        }
      }, 0) > 0
    );
  }

  function showMc12Snackbars() {
    if (track.shouldRecalculateGuideRails) {
      dispatch(showSnackbar({ id: "MC12_RECALCULATE_GUIDERAILS" }));
    } else if (!continueCondition()) {
      dispatch(showSnackbar({ id: "MISSING_OR_INCORRECT_FIELD" }));
    }
  }

  return (
    <div className="h-full flex flex-col pt-2 gap-5">
      <div className="flex flex-col sm:flex-row gap-5 overflow-y">
        <div className="w-full shadow-[0_4px_10px_0_rgba(0,0,0,0.25)] p-5 flex flex-col gap-y-7 bg-[#FAFAFA]">
          <Suspense fallback={<Spinner />}>
            <TrackBuilder />
          </Suspense>
        </div>
        <div className="w-full shadow-[0_4px_10px_0_rgba(0,0,0,0.25)] p-5 flex flex-col gap-y-7">
          <TrackInfo />
        </div>
      </div>
      <div className="p-5">
        <Navigator
          continueButtonDisabled={!continueCondition()}
          continueAction={() => {
            if (continueCondition()) {
              dispatch(setMc12CurrentStep(mc12Steps.ELECTRICAL_INSTALLATION));
              dispatch(updateConfiguration());
            } else {
              showMc12Snackbars();
            }
          }}
        />
      </div>
    </div>
  );
};

export default BuildTrack;
